import { TextField } from '@mui/material'
import styled from 'styled-components'

const StyledTextField = styled(TextField)`
  width: 100%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.2s ease;

    &:hover {
      border-color: #6779e3;
    }

    &.Mui-focused {
      border-color: #6779e3;
      box-shadow: 0 0 0 3px rgba(103, 121, 227, 0.1);
    }
  }

  .MuiOutlinedInput-input {
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.5;
  }
`

export default function ScreeningTextBox({ question, answer, onChange }) {
  return (
    <StyledTextField
      multiline
      rows={4}
      value={answer?.response || ''}
      placeholder={`Enter your answer...`}
      onChange={(e) => {
        onChange({ ...answer, response: e.target.value })
      }}
      variant="outlined"
      fullWidth
    />
  )
}
